import { Notification, NotificationType } from '../types/notification.types';

export const NOTIFICATION_TYPE_META: Record<
  NotificationType,
  { icon: string; label: string; tone: 'primary' | 'amber' | 'danger' | 'muted' }
> = {
  ORDER_MODIFIED: { icon: 'edit-2', label: 'Modifiée', tone: 'amber' },
  ORDER_ASSIGNED: { icon: 'user-check', label: 'Assignée', tone: 'primary' },
  ORDER_UNASSIGNED: { icon: 'user-x', label: 'Retrait', tone: 'muted' },
  STATUS_CHANGED: { icon: 'arrows-rotate', label: 'Statut', tone: 'primary' },
  COMMENT_ADDED: { icon: 'message-square', label: 'Note', tone: 'primary' },
  ORDER_DELETED: { icon: 'trash', label: 'Supprimée', tone: 'danger' },
  DELIVERY_STATUS_UPDATED: { icon: 'truck', label: 'Livraison', tone: 'amber' },
  ALERT_CHANGED: { icon: 'alert-triangle', label: 'Alerte', tone: 'amber' },
  CENTRE_MESSAGE: { icon: 'message-square', label: 'Centre', tone: 'primary' }
};

export const NOTIFICATION_TYPE_FILTERS: { value: NotificationType | 'all'; label: string }[] = [
  { value: 'all', label: 'Tous' },
  { value: 'ORDER_ASSIGNED', label: 'Assignée' },
  { value: 'ORDER_UNASSIGNED', label: 'Retrait' },
  { value: 'ORDER_MODIFIED', label: 'Modifiée' },
  { value: 'STATUS_CHANGED', label: 'Statut' },
  { value: 'COMMENT_ADDED', label: 'Note' },
  { value: 'DELIVERY_STATUS_UPDATED', label: 'Livraison' },
  { value: 'ORDER_DELETED', label: 'Supprimée' },
  { value: 'ALERT_CHANGED', label: 'Alerte' },
  { value: 'CENTRE_MESSAGE', label: 'Centre' }
];

export const notificationMeta = (type: NotificationType) =>
  NOTIFICATION_TYPE_META[type] || { icon: 'bell', label: 'Notif', tone: 'muted' as const };

const readNotificationData = (notification: Pick<Notification, 'data'>): Record<string, unknown> => {
  const raw = notification.data;
  if (!raw) return {};
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw);
    } catch {
      return {};
    }
  }
  return raw;
};

export const notificationHref = (
  notification: Pick<Notification, 'type' | 'entity_type' | 'entity_id' | 'data' | 'store_id'>
): string | null => {
  if (notification.type === 'CENTRE_MESSAGE' || notification.entity_type === 'centre') {
    const data = readNotificationData(notification);
    if (typeof data.url === 'string' && data.url.startsWith('/')) return data.url;
    const params = new URLSearchParams();
    const storeId = data.storeId || data.store_id || notification.store_id;
    const channel = data.channel || 'whatsapp';
    const contact = data.contactId || data.contact || data.phone;
    if (storeId) params.set('store', String(storeId));
    params.set('channel', String(channel));
    if (contact) params.set('contact', String(contact));
    return `/centre?${params.toString()}`;
  }
  if (notification.entity_type === 'order' && notification.entity_id) {
    return `/orders?orderId=${notification.entity_id}`;
  }
  return null;
};

export const formatNotificationTime = (dateString: string): string => {
  const date = new Date(dateString);
  const now = new Date();
  const diff = now.getTime() - date.getTime();
  const minutes = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);
  const days = Math.floor(diff / 86400000);

  if (minutes < 1) return "À l'instant";
  if (minutes < 60) return `${minutes} min`;
  if (hours < 24) return `${hours} h`;
  if (days < 7) return `${days} j`;
  return date.toLocaleDateString('fr-FR', {
    day: 'numeric',
    month: 'short',
    year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined
  });
};
